import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, Observable, firstValueFrom} from "rxjs";
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class TableTransactionsService {

  // @ts-ignore
  private _products$ = new BehaviorSubject<table[]>([]);
  private _total$ = new BehaviorSubject<number>(0);
  get products$() { return this._products$.asObservable(); }
  get total$() { return this._total$.asObservable(); }
  page = 1;
  pageSize = 10

  constructor(private http: HttpClient, private authService : AuthService) {
  }

  private url(path: string): string {
      const base =
        this.authService.getOriginCurrency() !== 'BRL'
          ? environment.intlUrl   
          : environment.apiUrl;

      return `${base}${path}`;
    }

  getReceiptTemplate(): Observable<string> {
    return this.http.get('/assets/templates/HtmlComprovantePix.html', { responseType: 'text' });
  }

  resendWebhook(ids: string[]): Promise<any> {
    return firstValueFrom(
      this.http.post(this.url('/webhook/reprocess'), { transactionIds: ids })
    );
  }
  
  getAccount() : Promise<any>{
    return firstValueFrom(this.http.get(`${environment.apiUrl}/account`));
  }

  getTransactionDetail(id: string): Promise<any> {
    return firstValueFrom(
      this.http.get(this.url('/gettransactiondetail'), {
        params: { id }            
      })
    );
  }

  resendRefund(id: string): Promise<any> {
  return firstValueFrom(
    this.http.post(this.url('/refund'), {
      id: id
    })
  );
}

}
